<template>
    <Stepper>
        <DetailsSection no-border class="pb-0">
            <TopSection>
                <template v-slot:header>
                    {{$t('Cancellation.header')}}
                </template>
            </TopSection>
        </DetailsSection>

        <CancellationScopeSection v-if="cancellationInfo.numberOfVoucherCodes > 1"
                                  :number-of-voucher-codes="cancellationInfo.numberOfVoucherCodes"
                                  :cancelCompleteOrder.sync="cancellation.cancelCompleteOrder"
        />

        <CancellationReasonSection :cancellationReason.sync="cancellation.cancellationReason"
                                   :cancellationText.sync="cancellation.cancellationText" />

        <RefundSection is-value-voucher
                       :amountToRefund="cancellationInfo.amountForRefund"
                       :originalPaymentStatus="cancellationInfo.originalPaymentStatus"
                       :refund-method.sync="cancellation.refundMethod"
                       :originalPaymentMethod="cancellationInfo.originalPaymentMethod" />

        <DetailsSection>
            <input type="hidden" name="action" value="cancel" />

            <div class="text-center">
                <button class="btn btn-primary btn-lg text-uppercase" type="submit">
                    {{$t('Cancellation.button.sendCancellation')}}
                </button>
            </div>
        </DetailsSection>
    </Stepper>
</template>

<script>
    import TopSection from '@/components/checkout/TopSection';
    import CancelableText from '@/components/cancellation/CancelableText';
    import Stepper from '@/components/checkout/Stepper';
    import DetailsSection from '@/components/DetailsSection';
    import CancellationReasonSection from '@/components/cancellation/CancellationReasonSection';
    import CancellationScopeSection from '@/components/cancellation/CancellationScopeSection';
    import RefundSection from '@/components/cancellation/RefundSection';

    export default {
        name: 'ValueVoucherCancellation',
        components: {
            TopSection,
            CancelableText,
            Stepper,
            DetailsSection,
            CancellationReasonSection,
            CancellationScopeSection,
            RefundSection
        },
        data() {
            return {
                cancelCompleteOrder: null,
                cancellationText: '',
                cancellationReason: '',
                refundMethod: 'OriginalPaymentMethod'
            };
        },
        props: {
            cancellationInfo: {
                type: Object,
                required: true
            },
            cancellation: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>
